import { Auth } from 'aws-amplify';

const environment = {
    production: true,
    debug: false,
    offline: false,
    cloudformationLaunchStackUrl: 'https://console.aws.amazon.com/cloudformation/home?region=eu-west-1#/stacks/create/review?stackName=VizCon&templateURL=https://vizcon-resources-prod.s3.amazonaws.com/iac/latest/crossAccountAccessRole.yml',
    cloudformationTemplateUrl: 'https://resources.vizcon.cloud/iac/latest/crossAccountAccessRole.yml',
    cognitoSelfSignUpEnabled: true,
    Amplify: {
        Auth: {
            region: 'eu-west-1',
            userPoolId: 'eu-west-1_f36tqSAN4',
            userPoolWebClientId: '16hc5n993rf3r439hacbe82i31',
        },
        API: {
            endpoints: [
                {
                    name: 'VizConAPI',
                    endpoint: 'https://api.vizcon.cloud',
                    custom_header: async () => {
                        return { Authorization: (await Auth.currentSession()).getIdToken().getJwtToken() };
                    }
                }
            ]
        }
    },
    features: {
        subscriptions: true,
        userInvitation: false
    },
    stripe: {
        enabled: true,
        "redirectUrl": "https://app.vizcon.cloud"
    },
    aws: {
        enabled: true,  // temporarily disabled
        marketplaceUrl: "https://aws.amazon.com/marketplace/pp/prodview-7ed2nglddp7ho", // Lifetime product URL
        marketplaceUrlSubscription: "https://aws.amazon.com/marketplace/pp/prodview-yagp2ptvthuf6",  // Subscription product URL (monthly/yearly)
        subscriptionManagementUrl: "https://console.aws.amazon.com/marketplace/subscriptions",
        productCode: "58awr0hw0ykk5m27c2qlp34qp",  // Lifetime product code
        productCodeSubscription: "mflzja8o0f8rh7tbqpwyusx5"  // Subscription product code (monthly/yearly)
    },
    defaultRoleName: "vizcon",
    matomo: {
        enabled: true,
        containerUrl: "https://cdn.matomo.cloud/mksolutions.matomo.cloud/container_RedYMixc.js"
    },
    branding: {
        logoPath: "assets/img/logo/vizcon-logo.png",
        logoAlt: "VizCon Logo",
        companyName: "VizCon"
    },
    license: {
        expiryDate: null,  // Optional: ISO date string (e.g., "2024-12-31T23:59:59Z") for POC/trial licenses
        warningDays: 7     // Show warning X days before expiry
    }
};

export default environment;
